import { Backdrop, Box, CircularProgress, Typography } from '@mui/material';

interface AsyncBackdropSubmitProps {
    children: React.ReactNode;
    onClick?: () => Promise<void>;
    isLoading: boolean;
}

function AsyncBackdropSubmit({ children, ...props }: AsyncBackdropSubmitProps) {
  const { isLoading = false } = props;
  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isLoading}
    >
      <Box display='flex' alignItems='center'
        alignContent='center' flexDirection='column'>
        <CircularProgress color='inherit' />
        <Typography mt={3} variant='h4'>
          {children}
        </Typography>
      </Box>

    </Backdrop>

  );
}

export default AsyncBackdropSubmit;